import { useMutation } from "@apollo/client"
import { UPLOAD_IMAGE } from "../queries/uploadImage"
import { toast } from "@/components/ui/use-toast"
import { useAuthContext } from "@/contexts/AuthContext"

export interface UploadImageInput {
  personId?: number
  tournamentId?: number
  tournamentTypeId?: number
  gameId?: number
  storeId?: number
  field?: string
  type:
    | "user.avatar"
    | "tournament.image"
    | "store.logo"
    | "store.cover"
    | "tournamenttype.image"
    | "game.image"
  image: string // base64 string
  name: string // nombre de la imagen
}

export const useUploadImage = () => {
  const { refetch } = useAuthContext()
  const [uploadImage, { loading, error }] = useMutation(UPLOAD_IMAGE, {
    onCompleted: (data) => {
      if (data.UploadImage.status.success) {
        toast({
          title: "Imagen subida",
          variant: "success",
          description: "Tu imagen ha sido actualizada correctamente",
        })
        // Refetch user data to update the context
        refetch?.()
      } else {
        toast({
          title: "Error al subir imagen",
          description: data.UploadImage.status.detail || "Ocurrió un error al subir la imagen",
          variant: "destructive",
        })
      }
    },
    onError: () => {
      toast({
        title: "Error",
        description: "Ocurrió un error al subir la imagen",
        variant: "destructive",
      })
    },
  })

  const uploadImageUser = ({
    personId,
    image,
    name,
    type,
    tournamentId,
    field,
    tournamentTypeId,
    gameId,
  }: UploadImageInput) => {
    return uploadImage({
      variables: {
        UploadImageInput: {
          personId,
          type,
          gameId,
          file: image,
          field,
          name,
          tournamentId,
          tournamentTypeId,
        },
      },
    })
  }

  return {
    uploadImageUser,
    loading,
    error,
  }
}
